module.exports = __webpack_public_path__ + "static/media/CERTIFICADO.2b063cc9.pdf";